import {Component,EventEmitter,inject,Input,Output} from '@angular/core';
import {Router} from '@angular/router';
import {faEllipsis} from '@fortawesome/free-solid-svg-icons';
import {delay,finalize} from 'rxjs';
import {AuthService} from 'src/app/auth/auth.service';
import {DefaultRoutes,FeatureRoutes} from 'src/app/core/routes';
import {Roles} from 'src/app/features/user/user';
import {GlobalService} from 'src/app/shared/services/global.service';
import {ModalService} from 'src/app/shared/services/modal.service';
import {BOARD_MESSAGES} from 'src/app/util/constantes-mensajes';
import {Reporte} from '../../reports/models/reporte';
import {ReportsService} from '../../reports/reports.service';
import {BoardsService} from '../boards.service';
@Component({
    selector: 'app-board-item',
    templateUrl: './board-item.component.html',
    styleUrls: ['./board-item.component.scss'],
    standalone: false
})
export class BoardItemComponent {
  // Board that user select
  @Input() board: Reporte;
  // This property emits an event when user removes a favorite board
  @Output() readonly removeFavorite = new EventEmitter();
  @Output() readonly onDelete = new EventEmitter();
  @Output() readonly handleDisableEnable=new EventEmitter();
  // Property to verify user role
  canInactivate = false;
  // Enables or disables loading spinner
  isLoading = false;
  // Ellipsis icon
  faEllipsis = faEllipsis;

  globalService = inject(GlobalService);

  constructor(
    private boardsService: BoardsService,
    private reportService: ReportsService,
    private modalService: ModalService,
    private router: Router,
    private authService: AuthService) {
    const rol = this.authService.user?.rol;
    this.canInactivate = rol === Roles.admin;
  }
  /**
   * Validates the favorite property on the selected board and emits an event
   * @param {boolean} value
   */
  onFavorite(value: boolean): void {
    this.boardsService.setFavorite(this.board.uuid).subscribe({
      next: () => {
        this.board.favorito = value;
        if (!this.board.favorito) {
          this.removeFavorite.emit();
        }
      },
      error: () => this.modalService.getConfirmacionModal({ message: BOARD_MESSAGES.UPDATE.ERROR_FAVORITE, confirmTitle: "Cerrar", isError: true }),
    });
  }

  /**
   * This function redirects to board detail page
   * @returns None
   */
  loadEmbeddedBoard() {
    this.router.navigateByUrl(`${DefaultRoutes.dataVisualization}${FeatureRoutes.boards}/${this.board.uuid}`);
  }

  /**
   * Deletes current board by uuid
   * @param {Reporte} board
   */
  deleteBoard(board: Reporte) {
    this.modalService.getConfirmacionModal({ message: BOARD_MESSAGES.DELETE.QUESTION, closeTitle: "Cancelar", confirmTitle: "Aceptar" }).result.then((response: boolean) => {
      if (response) {
        this.onDelete.emit(this.board.uuid);
        this.boardsService.deleteReport(board.uuid)
          .pipe(
            delay(500),
            finalize(() => { this.isLoading = false }))
          .subscribe({
            next: () => {
              this.modalService.getConfirmacionModal({ message: BOARD_MESSAGES.DELETE.BOARD, confirmTitle: "Aceptar" });
            },
            error: (error) => {
              this.modalService.getConfirmacionModal({ message: error.error.message, confirmTitle: "Cerrar", isError: true });
            }
          });
      }
    });
  }

  /**
  * A function that call disable report service
  * @returns None
  */
  disableReport()
  {
    this.reportService.disableReport(this.board.uuid).subscribe({
      next: () =>
      {
        this.handleDisableEnable.emit(this.board.uuid);
        this.modalService.getConfirmacionModal({
          message: "Proceso realizado correctamente.",
          confirmTitle: "Cerrar",
          isError: false
        });

      },
      error: () =>
      {
        this.modalService.getConfirmacionModal({
          message: BOARD_MESSAGES.DISABLE.ERROR,
          confirmTitle: "Cerrar",
          isError: true
        });
      },
    });
  }

}